import React, { useContext } from 'react'
import { css } from '@emotion/native'
import { Image } from 'react-native'
import { ThemeContext, H3, Text, View } from './../pagui'
import { LG_SIZE } from '~/pagui/components/View'
import PagilyApp from './PagilyApp'

type Props = {
  title: string
  img: string
  content: string
  blue?: boolean
  yellow?: boolean
  isRight?: boolean
  isLeft?: boolean
  width?: boolean
  isMarginLeft?: boolean
  isGif?: boolean
  isBackground?: boolean
  imgBackground?: string
  isApp?: boolean
  alt? : string
}

const ViewStyle = css({
  width: '80%',
})

const imgStyle = css({
  resizeMode: 'contain',
})

const imgWidthScreen = css({
  width: '56%',
})

const imgWidth = css({
  width: 500,
  height: 500,
})
const height = css({
  height: 700,
})
const imgHeight = css({
  height: 700,
})
const left = css({
  marginLeft: 'auto',
})

const middle = css({
  margin: 'auto',
})

const titleStyle = css({
  fontSize: 30,
})

const contentStyle = css({
  fontSize: 20,
  lineHeight: 25,
})

const blockText = css({
  width: '30%',
  justifyContent: 'center',
})

const circle = css({
  width: 10,
  height: 10,
  borderRadius: 100,
})

const blueCircle = css({
  backgroundColor: '#327AE7',
})

const yellowCircle = css({
  backgroundColor: '#F5C909',
})

const redCircle = css({
  backgroundColor: '#FF6557',
})

const backgroundImg = css({
  width: 300,
  height: 300,
  resizeMode: 'contain',
  position: 'absolute',
  zIndex: -100,
  bottom: 10,
})

const backgroundLeft = css({
  left: -150,
})
// RESP ----------------------------------

const ViewStyleLG = css({
  width: '100%',
})

const imgStyleLG = css({
  width: '100%',
  height: 400,
  resizeMode: 'contain',
})

const blockTextLG = css({
  width: '100%',
  justifyContent: 'center',
})

const titleStyleLG = css({
  fontSize: 20,
})

const contentStyleLG = css({
  fontSize: 15,
  lineHeight: 20,
})

const FeaturesImpress: React.FC<Props> = ({
  title,
  img,
  content,
  blue,
  yellow,
  isRight,
  width,
  isMarginLeft,
  isGif,
  isBackground,
  imgBackground,
  isApp,
  alt
}) => {
  const [theme] = useContext(ThemeContext)
  const colorCircle = blue ? blueCircle : yellow ? yellowCircle : redCircle
  const widthImg = width ? imgWidth : imgWidthScreen
  const margin = isMarginLeft ? left : middle
  const heightStyle = isGif ? imgHeight : height

  return isRight ? (
    <>
      <View
        minShowSize={LG_SIZE}
        style={[ViewStyle, left, theme.styles.flexRowSpaceBetween]}
      >
        <View style={[blockText]}>
          <H3 style={[titleStyle, theme.styles.mb3]}>{title}</H3>
          <View style={[circle, colorCircle, theme.styles.mb3]} />
          <Text style={[contentStyle]}>{content}</Text>
        </View>
        <Image
          style={[
            height,
            widthImg,
            imgStyle,
            margin,
            theme.styles.mt3,
            theme.styles.mb2,
          ]}
          source={{ uri: img }}
          accessibilityLabel={alt}
        ></Image>
      </View>

      <View
        maxShowSize={LG_SIZE}
        style={[ViewStyleLG, left, theme.styles.flexCol, theme.styles.mb3]}
      >
        <Image
          style={[imgStyleLG, left, theme.styles.mt3, theme.styles.mb1]}
          source={{ uri: img }}
          accessibilityLabel={alt}
        ></Image>
        <View style={[blockTextLG, theme.styles.pl3, theme.styles.pr3]}>
          <H3 style={[titleStyleLG, theme.styles.mb1]}>{title}</H3>
          <View style={[circle, colorCircle, theme.styles.mb1]} />

          <Text style={[contentStyleLG]}>{content}</Text>
        </View>
      </View>
    </>
  ) : (
    <>
      <View
        minShowSize={LG_SIZE}
        style={[ViewStyle, theme.styles.flexRowSpaceBetween]}
      >
        <Image
          style={[
            heightStyle,
            widthImg,
            imgStyle,
            theme.styles.mt3,
            theme.styles.mb2,
            { marginRight: 'auto' },
          ]}
          source={{ uri: img }}
          accessibilityLabel={alt}
        ></Image>
        <View style={[blockText, theme.styles.ml4]}>
          <H3 style={[titleStyle, theme.styles.mb3]}>{title}</H3>
          <View style={[circle, colorCircle, theme.styles.mb3]} />
          {isBackground ? (
            <>
              <Image
                style={[backgroundImg, backgroundLeft]}
                source={{ uri: imgBackground }}
                
              />
              <Text style={[contentStyle]}>{content}</Text>
            </>
          ) : (
            <Text style={[contentStyle]}>{content}</Text>
          )}
          {isApp ? <PagilyApp /> : <></>}
        </View>
      </View>
      <View maxShowSize={LG_SIZE} style={[ViewStyleLG, theme.styles.flexCol]}>
        <Image
          style={[imgStyleLG, theme.styles.mt3, theme.styles.mb2]}
          source={{ uri: img }}
          accessibilityLabel={alt}
        ></Image>
        <View style={[blockTextLG, theme.styles.pl3, theme.styles.pr3]}>
          <H3 style={[titleStyleLG, theme.styles.mb1]}>{title}</H3>
          <View style={[circle, colorCircle, theme.styles.mb1]} />
          {isBackground ? (
            <>
              <Image style={[backgroundImg]} source={{ uri: imgBackground }} />
              <Text style={[contentStyleLG]}>{content}</Text>
            </>
          ) : (
            <Text style={[contentStyleLG]}>{content}</Text>
          )}
          {isApp ? <PagilyApp /> : <></>}
        </View>
      </View>
    </>
  )
}

export default FeaturesImpress
